import { APP_KEY_IDS } from "../../../constants/constants";
import MessageWindow from "../../message/messsage-window/MessageWindow";
import Signin from "../../sign-in/Signin";
import BaseMobileAppContainer from "../base-mobile-app-container/BaseMobileAppContainer";
import Styles from "./SamsungMessages.module.scss";
import MyImage from "../../../res/images/me.png"
import { useContext, useState } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { FacebookAuthProvider, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth, facebookAuthProvider, googleAuthProvider } from "../../../useFirebaseInit";

const SamsungMessages = () => {

    const {userId} =useContext(AuthContext)
    
    const [profileDetails, setPrrofileDetails] = useState({
        id: "0",
        label: "Priyansh Datyal",
        icon: MyImage
    })

    return (
        <BaseMobileAppContainer
            appId={APP_KEY_IDS.MOBILE_MESSAGES}
            loadFromX={30}
            title={"Message"}
            MainMenuOptions={
                <div className={Styles.container}>
                        <Signin/>
                </div>
            }
            MainScreen={<MessageWindow  profileDetails={profileDetails}/>}
            isMainScreenActive={!!userId}
        />
    )
}

export default SamsungMessages
